'use client';

import React from 'react';
import Translation from '@/utils/translation';

const TranslationContext = React.createContext({
  translations: {},
} as {
  translations: Translation;
});

export const TranslationProvider = (props: {
  children: React.ReactNode;
  lang: string;
}) => (
  <TranslationContext.Provider
    value={{ translations: new Translation(props.lang ?? 'en') }}
  >
    {props.children}
  </TranslationContext.Provider>
);

export default TranslationContext;
